import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import { getLanguage } from "@utils/LanguageUtils";

import { CourseModel } from "@common/domain/models/Course";
import { guestCoursesList } from "@common/redux/course/actions";
import { guestCoursesListErrorSelector, guestCoursesListLoaderSelector, guestCoursesListSelector } from "@common/redux/course/selectors";

import { translate } from "@translations/Translater";

import Shimmer from "@components/atoms/Shimmer";
import { sectionSetting } from "@components/molecules/Slider/SettingConstant";
import MultipleSlider from "@components/Slider/MultipleSlider";
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import { DEFAULT_PAGE_NUMBER } from "@constants/config";

import { SelfServeCourseMessage } from "@containers/SelfServeCourse/messages";

import PopularClassCard from "@presentation/Home/StudentDashboard/components/PopularClassCard";

import "./styles.less";

interface IProps {
    getGuestCoursesList?: (payload) => void;
    guestCoursesListLoader?: boolean;
    guestCourseListError?: string;
    guestCoursesList?: CourseModel[];
}

const GuestCourseList = (props: IProps) => {
    const { getGuestCoursesList, guestCoursesListLoader, guestCourseListError, guestCoursesList } = props;
    const { t } = useTranslation();
    useEffect(() => {
        getGuestCoursesList({ language: getLanguage(), page: DEFAULT_PAGE_NUMBER, limit: 50 })
    }, []);

    if (guestCoursesListLoader) {
        return <Shimmer />
    }

    return (
        <div className="guest_course_list__container">
            <Text
                textType={TextType.h1}
                fontFamilyVariant={FontFamilyVariant.bold}
                className={"popular_class_heading"}
                text={translate(t, SelfServeCourseMessage.selfServeCourseHeading)}
            />
            <Text
                textType={TextType.paragraph2}
                fontFamilyVariant={FontFamilyVariant.regular}
                className={"popular_class_description"}
                text={translate(t, SelfServeCourseMessage.selfServeCourseDesc)}
            />
            {guestCoursesList && guestCoursesList.length > 0 && !guestCoursesListLoader && <MultipleSlider customSetting={sectionSetting}>
                {(guestCoursesList?.concat({} as any)?.map((item: CourseModel) => {
                    if (Object.keys(item)?.length === 0) {
                        return null;
                    }
                    return (
                        <PopularClassCard courseDetails={item} key={item?.getCourseId()} />
                    );
                }))}
            </MultipleSlider>}
        </div>

    )
}

export const mapStateToProps = (state) => {
    return {
        guestCoursesList: guestCoursesListSelector(state),
        guestCoursesListLoader: guestCoursesListLoaderSelector(state),
        guestCoursesListError: guestCoursesListErrorSelector(state),
    }
}

export const mapDispatchToProps = (dispatch) => {
    return {
        getGuestCoursesList: (payload) => dispatch(guestCoursesList(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestCourseList);

